import _defineProperty from "/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useId as e } from "@radix-ui/react-id";
import * as o from "@radix-ui/react-collapsible";
import { createCollapsibleScope as r } from "@radix-ui/react-collapsible";
import { Primitive as t } from "@radix-ui/react-primitive";
import { useControllableState as c } from "@radix-ui/react-use-controllable-state";
import { composeEventHandlers as n } from "@radix-ui/primitive";
import { useComposedRefs as i } from "@radix-ui/react-compose-refs";
import { createCollection as a } from "@radix-ui/react-collection";
import { createContextScope as l } from "@radix-ui/react-context";
import d from "react";
import p from "@babel/runtime/helpers/esm/extends";

var s = ["Home", "End", "ArrowDown", "ArrowUp"],
    _a = a("Accordion"),
    _a2 = _slicedToArray(_a, 3),
    u = _a2[0],
    m = _a2[1],
    f = _a2[2],
    _l = l("Accordion", [f, r]),
    _l2 = _slicedToArray(_l, 2),
    A = _l2[0],
    g = _l2[1];

export { g as createAccordionScope };
var b = r();
export var Accordion = /*#__PURE__*/d.forwardRef(function (e, o) {
  var r = e.type,
      t = _objectWithoutProperties(e, ["type"]),
      c = t,
      n = t;
  /*#__PURE__*/


  return d.createElement(u.Provider, {
    scope: e.__scopeAccordion
  }, "multiple" === r ? /*#__PURE__*/d.createElement(I, p({}, n, {
    ref: o
  })) : /*#__PURE__*/d.createElement(y, p({}, c, {
    ref: o
  })));
});
/*#__PURE__*/

Accordion.propTypes = {
  type: function type(e) {
    var o = e.value || e.defaultValue;
    return e.type && !["single", "multiple"].includes(e.type) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected one of `single | multiple`.") : "multiple" === e.type && "string" == typeof o ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `single` when `defaultValue` or `value` is type `string`.") : "single" === e.type && Array.isArray(o) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `multiple` when `defaultValue` or `value` is type `string[]`.") : null;
  }
};

var _A = A("Accordion"),
    _A2 = _slicedToArray(_A, 2),
    x = _A2[0],
    v = _A2[1],
    _A3 = A("Accordion", {
  collapsible: !1
}),
    _A4 = _slicedToArray(_A3, 2),
    E = _A4[0],
    w = _A4[1],
    y = /*#__PURE__*/d.forwardRef(function (e, o) {
  var r = e.value,
      t = e.defaultValue,
      _e$onValueChange = e.onValueChange,
      n = _e$onValueChange === void 0 ? function () {} : _e$onValueChange,
      _e$collapsible = e.collapsible,
      i = _e$collapsible === void 0 ? !1 : _e$collapsible,
      a = _objectWithoutProperties(e, ["value", "defaultValue", "onValueChange", "collapsible"]),
      _c = c({
    prop: r,
    defaultProp: t,
    onChange: n
  }),
      _c2 = _slicedToArray(_c, 2),
      l = _c2[0],
      s = _c2[1];
  /*#__PURE__*/


  return d.createElement(x, {
    scope: e.__scopeAccordion,
    value: l ? [l] : [],
    onItemOpen: s,
    onItemClose: d.useCallback(function () {
      return i && s("");
    }, [i, s])
  }, /*#__PURE__*/d.createElement(E, {
    scope: e.__scopeAccordion,
    collapsible: i
  }, /*#__PURE__*/d.createElement(C, p({}, a, {
    ref: o
  }))));
}),
    I = /*#__PURE__*/d.forwardRef(function (e, o) {
  var r = e.value,
      t = e.defaultValue,
      _e$onValueChange2 = e.onValueChange,
      n = _e$onValueChange2 === void 0 ? function () {} : _e$onValueChange2,
      i = _objectWithoutProperties(e, ["value", "defaultValue", "onValueChange"]),
      _c3 = c({
    prop: r,
    defaultProp: t,
    onChange: n
  }),
      _c4 = _slicedToArray(_c3, 2),
      _c4$ = _c4[0],
      a = _c4$ === void 0 ? [] : _c4$,
      l = _c4[1],
      s = d.useCallback(function (e) {
    return l(function () {
      var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return [].concat(_toConsumableArray(o), [e]);
    });
  }, [l]),
      u = d.useCallback(function (e) {
    return l(function () {
      var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return o.filter(function (o) {
        return o !== e;
      });
    });
  }, [l]);
  /*#__PURE__*/


  return d.createElement(x, {
    scope: e.__scopeAccordion,
    value: a,
    onItemOpen: s,
    onItemClose: u
  }, /*#__PURE__*/d.createElement(E, {
    scope: e.__scopeAccordion,
    collapsible: !0
  }, /*#__PURE__*/d.createElement(C, p({}, i, {
    ref: o
  }))));
}),
    _A5 = A("Accordion"),
    _A6 = _slicedToArray(_A5, 2),
    _ = _A6[0],
    h = _A6[1],
    C = /*#__PURE__*/d.forwardRef(function (e, o) {
  var r = e.__scopeAccordion,
      c = e.disabled,
      a = _objectWithoutProperties(e, ["__scopeAccordion", "disabled"]),
      l = d.useRef(null),
      f = i(l, o),
      A = m(r),
      g = n(e.onKeyDown, function (e) {
    var o;
    if (!s.includes(e.key)) return;
    var r = e.target,
        t = A().filter(function (e) {
      var o;
      return !(null !== (o = e.ref.current) && void 0 !== o && o.disabled);
    }),
        c = t.findIndex(function (e) {
      return e.ref.current === r;
    }),
        n = t.length;
    if (-1 === c) return;
    e.preventDefault();
    var i = c;

    switch (e.key) {
      case "Home":
        i = 0;
        break;

      case "End":
        i = n - 1;
        break;

      case "ArrowDown":
        i = c + 1;
        break;

      case "ArrowUp":
        i = c - 1, i < 0 && (i = n - 1);
    }

    null === (o = t[i % n].ref.current) || void 0 === o || o.focus();
  });
  /*#__PURE__*/


  return d.createElement(_, {
    scope: r,
    disabled: c
  }, /*#__PURE__*/d.createElement(u.Slot, {
    scope: r
  }, /*#__PURE__*/d.createElement(t.div, p({}, a, {
    ref: f,
    onKeyDown: c ? void 0 : g
  }))));
}),
    _A7 = A("AccordionItem"),
    _A8 = _slicedToArray(_A7, 2),
    R = _A8[0],
    k = _A8[1];

export var AccordionItem = /*#__PURE__*/d.forwardRef(function (r, t) {
  var c = r.__scopeAccordion,
      n = r.value,
      i = _objectWithoutProperties(r, ["__scopeAccordion", "value"]),
      a = h("AccordionItem", c),
      l = v("AccordionItem", c),
      s = b(c),
      u = e(),
      m = n && l.value.includes(n) || !1,
      f = a.disabled || r.disabled;
  /*#__PURE__*/


  return d.createElement(R, {
    scope: c,
    open: m,
    disabled: f,
    triggerId: u
  }, /*#__PURE__*/d.createElement(o.Root, p({
    "data-state": m ? "open" : "closed"
  }, s, i, {
    ref: t,
    disabled: f,
    open: m,
    onOpenChange: function onOpenChange(e) {
      e ? l.onItemOpen(n) : l.onItemClose(n);
    }
  })));
});
/*#__PURE__*/

export var AccordionHeader = /*#__PURE__*/d.forwardRef(function (e, o) {
  var r = e.__scopeAccordion,
      c = _objectWithoutProperties(e, ["__scopeAccordion"]),
      n = k("AccordionHeader", r);
  /*#__PURE__*/


  return d.createElement(t.h3, p({
    "data-state": (i = n.open, i ? "open" : "closed"),
    "data-disabled": n.disabled ? "" : void 0
  }, c, {
    ref: o
  }));
  var i;
});
/*#__PURE__*/

export var AccordionTrigger = /*#__PURE__*/d.forwardRef(function (e, r) {
  var t = e.__scopeAccordion,
      c = _objectWithoutProperties(e, ["__scopeAccordion"]),
      n = k("AccordionTrigger", t),
      i = w("AccordionTrigger", t),
      a = b(t);
  /*#__PURE__*/


  return d.createElement(u.ItemSlot, {
    scope: t
  }, /*#__PURE__*/d.createElement(o.Trigger, p({
    "aria-disabled": n.open && !i.collapsible || void 0,
    id: n.triggerId
  }, a, c, {
    ref: r
  })));
});
/*#__PURE__*/

export var AccordionContent = /*#__PURE__*/d.forwardRef(function (e, r) {
  var t = e.__scopeAccordion,
      c = _objectWithoutProperties(e, ["__scopeAccordion"]),
      n = k("AccordionContent", t),
      i = b(t);
  /*#__PURE__*/


  return d.createElement(o.Content, p({
    role: "region",
    "aria-labelledby": n.triggerId
  }, i, c, {
    ref: r,
    style: _objectSpread({
      "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
      "--radix-accordion-content-width": "var(--radix-collapsible-content-width)"
    }, e.style)
  }));
});
/*#__PURE__*/

export var Root = Accordion;
export var Item = AccordionItem;
export var Header = AccordionHeader;
export var Trigger = AccordionTrigger;
export var Content = AccordionContent;